// extracted by mini-css-extract-plugin
export default {"wrapper":"NU","header":"OU","headerwrap":"PU","title":"QU","icon":"RU","textwrap":"SU"};
    if(module.hot) {
      // 1726593107521
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  